<template>
  <b-sidebar
    id="edit-branch-sidebar"
    :visible="isEditBranchSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="populateLocalData"
    @hidden="hideSidebar"
    @change="val => $emit('update:is-edit-branch-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
Edit Branch
</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <validation-observer
ref="refFormObserver"
#default="{ invalid }"
>
        <b-form
          class="p-2"
          @submit.prevent="editBranch"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Branch Name"
            rules="required"
          >
            <b-form-group
              label="Branch Name"
              label-for="BranchName"
            >
              <b-form-input
                id="BranchName"
                v-model="branchData.branchName"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Branch Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Branch Code"
            rules="required"
          >
            <b-form-group
              label="Branch Code"
              label-for="BranchCode"
            >
              <b-form-input
                id="BranchCode"
                v-model="branchData.branchCode"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Branch Code"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Branch City"
            rules="required"
          >
            <b-form-group
              label="Branch City"
              label-for="BranchCity"
            >
              <b-form-input
                id="BranchCity"
                v-model="branchData.branchCity"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Branch City"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Branch Address"
            rules="required"
          >
            <b-form-group
              label="Branch Address"
              label-for="BranchAddress"
            >
              <b-form-input
                id="BranchAddress"
                v-model="branchData.branchAddress"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Branch Address"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Branch Phone"
            rules="required"
          >
            <b-form-group
              label="Branch Phone"
              label-for="BranchPhone"
            >
              <b-form-input
                id="BranchPhone"
                v-model="branchData.branchPhone"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Branch Phone"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Branch Fax"
          >
            <b-form-group
              label="Branch Fax"
              label-for="BranchFax"
            >
              <b-form-input
                id="BranchFax"
                v-model="branchData.branchFax"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Branch Fax"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Branch Region"
          >
            <b-form-group
              label="Branch Region"
              label-for="RegionID"
              :state="getValidationState(validationContext)"
            >
              <v-select-new
                v-model="branchData.regionId"
                name="RegionID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="regions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="RegionID"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              block
              :disabled="invalid || submitButtonDisabled"
            >
              Update
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hideSidebar"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import { ref } from '@vue/composition-api'
import moment from 'moment-timezone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isEditBranchSidebarActive',
    event: 'update:is-edit-branch-sidebar-active',
  },
  props: {
    isEditBranchSidebarActive: { type: Boolean, required: true },
    branchName: { type: String, default: '' },
    branchCode: { type: String, default: '' },
    branchId: { type: [String, Number], default: '' },
    branchCity: { type: String, default: '' },
    branchAddress: { type: String, default: '' },
    branchPhone: { type: String, default: '' },
    branchFax: { type: String, default: '' },
    branchRegionId: { type: [String, Number], default: '' },
  },
  data() {
    return {
      submitButtonDisabled: false,
      required,
      alphaNum,
      regions: [],
    }
  },
  setup() {
    const blankBranchData = {
      branchId: '',
      branchName: '',
      branchCode: '',
      branchCity: '',
      branchAddress: '',
      branchPhone: '',
      branchFax: '',
      regionId: null,
    }

    const branchData = ref(JSON.parse(JSON.stringify(blankBranchData)))

    const resetBranchData = () => {
      branchData.value = JSON.parse(JSON.stringify(blankBranchData))
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetBranchData)

    return {
      branchData,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  mounted() {
    this.getRegions()
  },
  methods: {
    hideSidebar() {
      this.$emit('update:is-edit-branch-sidebar-active', false)
      this.resetForm()
    },
    populateLocalData() {
      // Called when sidebar opens. Maps parent props down to local reactive object.
      this.branchData.branchId = this.branchId
      this.branchData.branchName = this.branchName
      this.branchData.branchCode = this.branchCode
      this.branchData.branchCity = this.branchCity
      this.branchData.branchAddress = this.branchAddress
      this.branchData.branchPhone = this.branchPhone
      this.branchData.branchFax = this.branchFax
      this.branchData.regionId = this.branchRegionId
    },
    getRegions() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      axios
        .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_REGION}`, { headers })
        .then(response => {
          if (response.data && response.data.data) {
            this.regions = response.data.data.map(elem => ({
              label: elem.region_name,
              value: elem.region_id,
              slug: elem.region_slug,
            }))
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    editBranch() {
      this.$refs.refFormObserver.validate().then(success => {
        if (!success) return

        this.submitButtonDisabled = true
        const userToken = this.$cookies.get('userToken')
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
        }

        const payload = {
          branch_id: this.branchData.branchId,
          branch_name: this.branchData.branchName,
          branch_code: this.branchData.branchCode,
          branch_city: this.branchData.branchCity,
          branch_address: this.branchData.branchAddress,
          branch_phone: this.branchData.branchPhone,
          branch_fax: this.branchData.branchFax,
          branch_region_id: this.branchData.regionId,
          time: moment().format(),
        }

        axios
          .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_EDIT_BRANCH}`, payload, { headers })
          .then(response => {
            this.submitButtonDisabled = false
            if (response.data.success === true) {
              this.hideSidebar()
              this.$root.$emit('refreshTable', 'refreshTable')
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: 'Your data has been modified!',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Notification',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: response.data.message || 'Something went wrong',
                },
              })
            }
          })
          .catch(error => {
            console.error(error)
            this.submitButtonDisabled = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Something went wrong',
              },
            })
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#edit-branch-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>